import { useDAL } from '@/contexts/useDAL';
import type { BackupVault } from '@/data/vaults/backupVault';
import { generateGcpKmsCommands } from './gcpKmsCommands';
import { CopyableCode } from '../shared/copyableCode';
export function GcpKmsCopyablePolicy({
  backupVault,
  scanningAccountId
}: {
  backupVault: BackupVault;
  scanningAccountId: string;
}) {
  const dal = useDAL();
  const {
    data: serviceAgent
  } = dal.cloudAccounts.scanning.useGetGcsServiceAgent(scanningAccountId);
  const kmsKey = backupVault.vaultAttributes.gcp?.encryptionKey || '';
  const kmsCommands = generateGcpKmsCommands(kmsKey, {
    scanningServiceAccount: serviceAgent?.scanningServiceAccount,
    gcsServiceAgent: serviceAgent?.gcsServiceAgent,
    restoreServiceAccounts: serviceAgent?.restoreServiceAccounts
  });
  return <CopyableCode title='vault_kms_perm.sh' code={kmsCommands} maxHeight='320px' />;
}